import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Col, DatePicker, Form, Input, Modal, Row, Select, Table} from 'antd'
import {withTranslation} from 'react-i18next'
import {getPaginationConfig} from '../../../components/pagination'
import moment from 'moment'

const {RangePicker} = DatePicker


const limitTypeMap = {
  '1': '营销短信',
  '2': '通知短信',
  '3': '邮件',
  '4': '外呼',
}

@inject('marketingManagementStore')
@observer
class LimitModal extends Component {
  state = {}

  formRef = React.createRef()

  handlePageChange = (pageNo, pageSize) => {
    const {marketingManagementStore, groupParams} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      const params = {
        ...groupParams,
        'actionType': fieldsValue.actionType,
        'startDate': fieldsValue.date ? moment(fieldsValue.date[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        'endDate': fieldsValue.date ? moment(fieldsValue.date[1]).format('YYYY-MM-DD HH:mm:ss') : '',
      }
      marketingManagementStore.groupLogPageNumAction(pageNo, pageSize, params).then()
    }).catch()
  }

  handleSearch = () => {
    const {marketingManagementStore, groupParams} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      const params = {
        ...groupParams,
        'actionType': fieldsValue.actionType,
        'startDate': fieldsValue.date ? moment(fieldsValue.date[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        'endDate': fieldsValue.date ? moment(fieldsValue.date[1]).format('YYYY-MM-DD HH:mm:ss') : '',
        'page': 1,
        'size': 10,
      }
      marketingManagementStore.groupLogList(params).then()
    }).catch()
  }

  render() {
    const {marketingManagementStore, addModalVisible, handleCancel, limitType} = this.props
    const {groupLogData, groupLogPageSize, groupLogPageNo, groupLogTotal} = marketingManagementStore
    const pagination = getPaginationConfig(groupLogPageNo, groupLogPageSize, groupLogTotal, this.handlePageChange)
    const columns = [
      {
        title: limitType === '4' ? '余额' : '额度',
        dataIndex: 'number',
        key: 'number',
        render: (text, record) => {
          return (<div>{limitType === '4' ? record.callBalance : text}</div>)
        }
      },
      {
        title: '操作类型',
        dataIndex: 'actionType',
        key: 'actionType',
        render: (text) => {
          return (<div>{text === '1' ? '增加' : '扣除'}</div>)
        }
      },
      {
        title: '备注',
        dataIndex: 'remark',
        key: 'remark',
      },
      {
        title: '时间',
        dataIndex: 'createTime',
        key: 'createTime',
      },
    ]
    return (
      <>
        <Modal
          title={`${limitTypeMap[limitType]}额度详情`}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'60%'}
          centered
          footer={null}
          rowKey={record => record.id}
        >
          <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={10}>
                <Form.Item name="actionType" label="操作类型">
                  <Select placeholder="请选择" allowClear>
                    <Select.Option key="1" value="1">增加</Select.Option>
                    <Select.Option key="2" value="2">扣除</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item name="date" label="创建时间">
                  <RangePicker showTime style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={4} style={{marginTop: 30}}>
                <Button onClick={this.handleSearch} type='danger'>搜索</Button>
              </Col>
            </Row>
          </Form>
          <Table columns={columns} dataSource={groupLogData} pagination={pagination}/>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(LimitModal)
